/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileResponse } from '../../models/profile-response';

export interface GetUserProfilesWhereIsAuditor$Params {

/**
 * Id of user.
 */
  id: number;
}

export function getUserProfilesWhereIsAuditor(http: HttpClient, rootUrl: string, params: GetUserProfilesWhereIsAuditor$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
  const rb = new RequestBuilder(rootUrl, getUserProfilesWhereIsAuditor.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileResponse>>;
    })
  );
}

getUserProfilesWhereIsAuditor.PATH = '/rest/user/{id}/profile/auditor';
